<template>
    <el-row>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="grid-stack-item">
            <div class="header">
                <h1>{{ $t('Edit Role Permission') }} ({{ $t('Role') }} : <span>{{ permissionForm.data.name }}</span>)</h1>
            </div>
            <div class="my-content">
                <div class="grid-stack-item-content">
                    <el-form :label-position="labelPosition" :model="permissionForm" ref="permissionForm" class="demo-permissionForm">
                        <el-row :gutter="20">
                            <el-form-item :label="$t('Permissions')">
                                <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="6" v-for="(module_permissions, key) in permissions"
                                    :key="key">
                                    <el-card class="box-card">
                                        <div slot="header">
                                            <label class="el-checkbox__label" style="color:black;">{{ key }}</label>
                                        </div>
                                        <el-checkbox-group size="mini" v-model="permissionForm.data.role_permissions">
                                            <el-col :lg="24" v-for="(permission) in module_permissions" :key="permission.id">
                                                <el-checkbox :value="permission.id" :label="permission.id">{{
                                                    permission.name }}</el-checkbox>
                                            </el-col>
                                        </el-checkbox-group>
                                    </el-card>
                                </el-col>
                            </el-form-item>
                            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <el-form-item class="no-margin">
                                    <el-button type="primary" @click="submitForm('permissionForm')">{{ $t('Save') }}</el-button>
                                    <router-link tag="el-button" to="/roles" class="el-button--cancel">{{ $t('Cancel')
                                        }}</router-link>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
            </div>
        </el-col>
    </el-row>
</template>
<script>
    export default {
        data() {
            return {
                labelPosition: "top",
                permissions: {},
                permissionForm: {
                    data: {}
                }
            };
        },
        mounted() {
            request({
                    url: "roles/" + this.$route.params.id,
                    method: "get",
                    params: {}
                })
                .then(response => {
                    this.permissionForm = response.data;
                })
                .catch(error => {});
            request({
                    url: "get-all-permissions",
                    method: "get",
                    async: false,
                    params: {}
                })
                .then(response => {
                    this.permissions = response.data.data;
                })
                .catch(error => {});
        },
        methods: {
            submitForm(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        request({
                                url: "roles/" + this.$route.params.id,
                                method: "patch",
                                data: this.permissionForm.data
                            })
                            .then(response => {
                                this.$notify({
                                    title: this.$t('Success'),
                                    message: response.data.message,
                                    type: "success",
                                    offset: 50
                                });
                            })
                            .catch(error => {
                                this.$notify({
                                    title: this.$t('Error'),
                                    message: error.response.data.message,
                                    type: "error",
                                    offset: 50
                                });
                            });
                    }
                });
            }
        }
    };

</script>
<style>
    .el-card__header {
        padding: 5px 5px;
    }

    .el-card__header .el-checkbox {
        margin-bottom: 0px !important;
    }

</style>



// WEBPACK FOOTER //
// src/components/Layout/Role/ShowRole.vue